import {IntlProvider as ReactIntlProvider} from 'react-intl';
import {connect} from 'react-redux';
import { getUIStyle } from '../reducers/ui-style';

const mapStateToProps = state => ({
    key: state.locales.locale + getUIStyle(state),
    locale: state.locales.locale,
    messages: state.locales.messages
});

export default connect(mapStateToProps)(ReactIntlProvider);
